"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSelfMigrate = exports.CSS = void 0;
var tslib_1 = require("tslib");
var hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
var icon_1 = require("../../components/icon");
var icons_1 = require("../../components/icon/icons");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var theme_palette_1 = require("../../components/theme.palette");
var index_1 = require("../../i18n/index");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var classnames_1 = require("../../util/classnames");
var auth_component_style_1 = require("./auth.component.style");
var migrate_user_ctrl_1 = require("./migrate.user.ctrl");
exports.CSS = {
    emailInput: 'c-MigrateUser__emailAddress',
    emailInputHasError: 'c-MigrateUser__emailAddress-has-error',
    validationError: 'c-MigrateUser__validationError',
    spinner: 'c-MigrateUser__spinner',
    formError: 'c-MigrateUser__formError',
    successIcon: 'c-MigrateUser__successIcon'
};
var Style = (_a = {},
    _a[exports.CSS.emailInput] = {
        borderRadius: theme_1.DefaultTheme.space(1),
        flexBasis: '100%',
        padding: theme_1.DefaultTheme.space(3),
        border: "2px solid ".concat(theme_palette_1.ColorPalette2022Branding.g9),
        boxSizing: 'border-box',
        width: '100%',
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
    },
    _a["".concat(exports.CSS.emailInput, ":focus, ").concat(exports.CSS.emailInput, ":focus-visible")] = {
        outline: 'none',
        borderColor: theme_palette_1.ColorPalette2022Branding.lightBlue
    },
    _a[exports.CSS.emailInputHasError] = {
        borderColor: "".concat(theme_palette_1.ColorPalette2022Branding.error, " !important"),
        borderBottomRightRadius: '0 !important',
        borderBottomLeftRadius: '0 !important'
    },
    _a[exports.CSS.validationError] = {
        background: theme_palette_1.ColorPalette2022Branding.error,
        borderBottomRightRadius: theme_1.DefaultTheme.space(1),
        borderBottomLeftRadius: theme_1.DefaultTheme.space(1),
        color: 'white',
        padding: theme_1.DefaultTheme.space(1)
    },
    _a["".concat(exports.CSS.spinner, " div")] = {
        border: "2px solid ".concat(theme_palette_1.ColorPalette2022Branding.g7),
        borderTopColor: 'transparent'
    },
    _a[exports.CSS.formError] = {
        color: theme_palette_1.ColorPalette2022Branding.error,
        textAlign: 'left',
        marginTop: theme_1.DefaultTheme.space(2)
    },
    _a[exports.CSS.successIcon] = {
        color: theme_palette_1.ColorPalette2022Branding.success,
        fontSize: theme_1.DefaultTheme.space(8),
        marginBottom: theme_1.DefaultTheme.space(2)
    },
    _a);
(0, theme_1.addStyles)(auth_component_style_1.Style);
(0, theme_1.addStyles)(Style);
var UserSelfMigrate = /** @class */ (function (_super) {
    tslib_1.__extends(UserSelfMigrate, _super);
    function UserSelfMigrate() {
        var _this = _super.call(this) || this;
        _this.ctrl = new migrate_user_ctrl_1.MigrateUserController();
        // We still keep the reactions on the state component (instead of the controller) BECAUSE
        // the onRemove hook runs the disposers for any reactions we declare.
        _this.reaction(function () { return _this.ctrl.value; }, function () {
            _this.ctrl.isDirty = true;
            _this.ctrl.isValid = migrate_user_ctrl_1.MigrateUserController.validateEmail(_this.ctrl.value);
        });
        return _this;
    }
    Object.defineProperty(UserSelfMigrate.prototype, "validationError", {
        get: function () {
            if (!this.ctrl.isDirty || this.ctrl.isValid) {
                return null;
            }
            return (0, hyperscript_1.default)('div', {
                className: exports.CSS.validationError
            }, (0, index_1.Translate)(index_1.T.ENTER_VALID_EMAIL));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelfMigrate.prototype, "error", {
        get: function () {
            if (this.ctrl.formError) {
                return (0, hyperscript_1.default)('div', {
                    className: exports.CSS.formError
                }, this.ctrl.formError);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelfMigrate.prototype, "nodes", {
        get: function () {
            var _a;
            var _this = this;
            return (0, hyperscript_1.default)('form', { className: auth_component_style_1.CSS.container }, [
                (0, hyperscript_1.default)('div', {
                    className: auth_component_style_1.CSS.text
                }, (0, hyperscript_1.default)('div', {
                    className: auth_component_style_1.CSS.textInner
                }, (0, index_1.Translate)(index_1.T.SSO_UPGRADE_ACCOUNT))),
                this.ctrl.hasSubmitted
                    ? [
                        icon_1.Icon.view(icons_1.MaterialIcon.CHECK_CIRCLE, {
                            className: exports.CSS.successIcon
                        }),
                        (0, index_1.Translate)(this.ctrl.isNewUser ? index_1.T.SSO_MIGRATE_EMAIL_SENT : index_1.T.SSO_MIGRATE_EMAIL_EXISTING)
                    ]
                    : [
                        (0, hyperscript_1.default)('input', {
                            className: (0, classnames_1.classNames)(exports.CSS.emailInput, (_a = {},
                                _a[exports.CSS.emailInputHasError] = this.ctrl.hasError,
                                _a)),
                            placeholder: 'user@ikegps.com',
                            onkeyup: function (event) {
                                _this.ctrl.value = event.target.value;
                            },
                            value: this.ctrl.value,
                            disabled: this.ctrl.inFlight
                        }),
                        this.validationError,
                        this.error,
                        (0, hyperscript_1.default)('div', {
                            className: auth_component_style_1.CSS.padding
                        }, (0, hyperscript_1.default)('button', {
                            className: (0, classnames_1.classNames)('mdl-button', 'mdl-button--raised', auth_component_style_1.CSS.button),
                            onclick: function (event) {
                                event.preventDefault();
                                _this.ctrl.submit();
                            },
                            disabled: !this.ctrl.isDirty || this.ctrl.hasError || this.ctrl.inFlight
                        }, this.ctrl.inFlight ? spinner_1.Spinner.view(exports.CSS.spinner) : (0, index_1.Translate)(index_1.T.SUBMIT)))
                    ],
                (0, hyperscript_1.default)('div', {
                    className: auth_component_style_1.CSS.padding
                }, (0, hyperscript_1.default)('a', {
                    className: auth_component_style_1.CSS.link,
                    onclick: function () { return services_1.Services.Route.go(page_1.IkePageName.login); }
                }, (0, index_1.Translate)(index_1.T.BACK_TO_LOGIN)))
            ]);
        },
        enumerable: false,
        configurable: true
    });
    return UserSelfMigrate;
}(mithril_component_1.IMithrilStateComponent));
exports.UserSelfMigrate = UserSelfMigrate;
//# sourceMappingURL=migrate.user.js.map